var _defs, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.5,
    viewBox: "0 0 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2c9bd6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.732,1.768H12.964V.589a.589.589,0,1,0-1.179,0V1.768H4.714V.589a.589.589,0,1,0-1.179,0V1.768H1.768A1.768,1.768,0,0,0,0,3.536v11.2A1.768,1.768,0,0,0,1.768,16.5H14.732A1.768,1.768,0,0,0,16.5,14.732V3.536A1.768,1.768,0,0,0,14.732,1.768Zm.589,12.964a.589.589,0,0,1-.589.589H1.768a.589.589,0,0,1-.589-.589V7.071H15.321Zm0-8.839H1.179V3.536a.589.589,0,0,1,.589-.589H3.536V4.125a.589.589,0,1,0,1.179,0V2.946h7.071V4.125a.589.589,0,1,0,1.179,0V2.946h1.768a.589.589,0,0,1,.589.589V5.893Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.132 8.257)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M127.732,239.308a.589.589,0,0,0-.819,0l-4.3,4.3-1.941-1.941a.589.589,0,0,0-.833.833l2.357,2.357a.589.589,0,0,0,.833,0l4.714-4.714A.589.589,0,0,0,127.732,239.308Z",
    transform: "translate(-119.676 -239.143)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.405af84a.svg";
export { ForwardRef as ReactComponent };